import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[piqetAngularInputNumber]',
})
export class InputNumberDirective implements OnInit {
  @Input() preventNegative = false;
  @Input() minValue: number | null = null;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit(): void {
    if (this.minValue !== null) {
      this.el.nativeElement.setAttribute('min', this.minValue.toString());
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    // Prevent typing negative sign
    if (this.preventNegative && (event.key === '-' || event.code === 'Minus')) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedValue = event.clipboardData?.getData('text') || '';
    if (this.preventNegative && pastedValue.includes('-')) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;
    const selectionStart = input.selectionStart ?? originalValue.length;

    let sanitizedValue = originalValue;

    // Remove negative signs if needed
    if (this.preventNegative) {
      sanitizedValue = sanitizedValue.replace(/-/g, '');
    }

    // Enforce minValue
    const numericValue = parseFloat(sanitizedValue);
    if (this.minValue !== null && !isNaN(numericValue) && numericValue < this.minValue) {
      sanitizedValue = this.minValue.toString();
    }

    // Only update and reset cursor if value actually changed
    if (sanitizedValue !== originalValue) {
      input.value = sanitizedValue;

      const newPos = Math.min(selectionStart, sanitizedValue.length);
      setTimeout(() => {
        input.setSelectionRange(newPos, newPos);
      });
    }
  }
}
